module.exports = __webpack_public_path__ + "img/viewer_profile_gallery_husband.048a2f83.png";